import Vue from "vue";
import streamCart from "./streamCart.vue";

$("body").append(`<div id="app-stream-cart"></div>`);

new Vue({
	el: "#app-stream-cart",
	template: `<div><streamCart /></div>`,
	components: { streamCart },
});
